var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShopsPageShop4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 111,
    viewBox: "0 0 248 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 226,
    height: 89,
    rx: 10,
    fill: "#0079C2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.122 56.3439H106.722V58.5436H103.583V74H100.122V56.3439Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.636 67.3717L111.229 58.5436H111.428L112.021 67.3717H110.636ZM106.804 74H110.192L110.513 69.311H112.144L112.466 74H115.853L114.048 56.3439H108.608L106.804 74Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M120.81 67.8203V71.1489C120.81 71.5976 121.15 71.7278 121.349 71.7278C121.675 71.7278 121.902 71.4528 121.902 71.1489V67.0388C121.902 66.4889 121.803 65.8811 120.512 65.8811H119.107V63.9418H120.568C121.547 63.9418 121.902 63.7102 121.902 62.6248V59.1225C121.902 58.8186 121.675 58.5436 121.349 58.5436C121.15 58.5436 120.81 58.6594 120.81 59.1225V62.0025H117.348V59.4988C117.348 58.2687 117.49 56.3439 119.916 56.3439H122.782C125.208 56.3439 125.364 58.2687 125.364 59.4988V62.3209C125.364 64.2457 124.045 64.7667 123.009 64.7233V64.8969C125.336 64.8391 125.364 66.6626 125.364 67.2849V70.845C125.364 72.0896 125.208 74 122.782 74H119.916C117.49 74 117.348 72.0896 117.348 70.845V67.8203H120.81Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M127.633 56.3439H135.649V74H132.187V58.5436H131.095V74H127.633V56.3439Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M141.382 66.0547V58.5436H141.836C142.205 58.5436 142.474 58.862 142.474 59.4265V65.1719C142.474 65.7363 142.205 66.0547 141.836 66.0547H141.382ZM137.92 74H141.382V67.994H143.368C145.78 67.994 145.936 66.0837 145.936 64.8391V59.4988C145.936 58.2687 145.78 56.3439 143.368 56.3439H137.92V74Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M152.761 71.1489C152.761 71.4528 152.534 71.7278 152.208 71.7278C152.009 71.7278 151.669 71.5976 151.669 71.1489V59.1225C151.669 58.6594 152.009 58.5436 152.208 58.5436C152.534 58.5436 152.761 58.8186 152.761 59.1225V71.1489ZM148.207 70.845C148.207 72.0896 148.363 74 150.775 74H153.655C156.067 74 156.223 72.0896 156.223 70.845V59.4988C156.223 58.2687 156.067 56.3439 153.655 56.3439H150.775C148.363 56.3439 148.207 58.2687 148.207 59.4988V70.845Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M167.488 56.3439H171.999V74H168.537V62.9287H168.41L166.622 74H163.855L162.082 62.9287H161.954V74H158.492V56.3439H162.99L165.246 68.761L167.488 56.3439Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6352 32.2043C94.5753 27.4719 91.9192 23.6223 91.5532 23C90.9743 23.8828 88.856 27.2838 87.7791 31.0465C86.6029 35.2579 86.4298 38.9918 86.8356 42.6532C87.2385 46.3292 88.7609 50.1064 88.7609 50.1064C89.5697 52.0746 90.7813 54.202 91.5702 55.244C92.7266 53.71 95.384 49.1368 96.2126 43.1742C96.6737 39.8456 96.6936 36.9367 95.6352 32.2043ZM91.5532 54.0573C91.0325 53.0587 90.2237 51.1629 90.1471 48.2106C90.1273 45.374 91.2439 42.9282 91.5702 42.4217C91.8611 42.9282 92.823 45.0556 92.938 47.9645C93.016 50.8011 92.0909 53.0443 91.5532 54.0573ZM95.3273 40.2364C95.2875 42.0454 95.0761 43.9557 94.8066 45.099C94.903 43.1308 94.6718 40.3666 94.2291 38.1958C93.7864 36.0394 92.5336 32.4214 91.5333 30.7571C90.6097 32.349 89.4718 35.475 88.8759 38.1813C88.2771 40.8876 88.2601 44.1728 88.2601 45.1569C88.1012 44.332 87.7039 41.3652 87.816 38.3984C87.9096 35.9526 88.4715 33.42 88.7794 32.2622C89.9542 28.3981 91.2836 25.9234 91.5333 25.5326C91.783 25.9234 93.4573 28.977 94.3256 32.1754C95.1896 35.3737 95.3642 38.4418 95.3273 40.2364Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3516 56.3439H85.2941V61.8578C85.3012 61.8578 85.3068 61.8434 85.3139 61.8434C87.2123 59.9041 90.2912 59.9041 92.191 61.8434C94.0894 63.7682 94.0894 66.9086 92.191 68.8479C92.1825 68.8624 92.174 68.8624 92.1655 68.8768C92.1555 68.8768 92.1456 68.8913 92.1371 68.9058C90.2429 70.8161 87.7685 71.7713 85.2941 71.7713C82.8083 71.7713 80.3225 70.8161 78.427 68.8768C75.0842 65.4759 74.6884 60.1935 77.2366 56.3439C77.5799 55.8229 77.9758 55.3309 78.427 54.8678C80.3225 52.9285 82.8083 51.9733 85.2941 51.9733V38.7168C75.7425 38.7168 68 46.6041 68 56.3439C68 66.0837 75.7425 73.9855 85.2941 73.9855C90.2742 73.9855 94.7605 71.8292 97.916 68.3993V56.3439H93.3516Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: 0,
    y: 0,
    width: 248,
    height: 111,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopsPageShop4);
export default __webpack_public_path__ + "static/media/shopsPage_shop4.293ec3b36f8bac45b9775ceea50648bb.svg";
export { ForwardRef as ReactComponent };